import type { PoRun } from '@repo/sdk/gen'
import { Badge } from '@repo/ui/badge'
import { type TKey, useTranslation } from '@/lib/i18n'

// Each state of a document in its own colour, so the list reads at a glance:
// the engine's states in neutral and violet, the desk in sky, done in green,
// history in stone, failure in red. Amber stays free for flagged rows.
function RunStatusBadge(props: { status: PoRun['status'] }) {
	const { t } = useTranslation()
	const status = RUN_STATUSES[props.status]

	return (
		<Badge className={status.tone} variant='secondary'>
			{t(status.label)}
		</Badge>
	)
}

const RUN_STATUSES = {
	pending: {
		label: 'po:status.pending',
		tone: 'bg-muted text-muted-foreground'
	},
	running: {
		label: 'po:status.running',
		tone: 'bg-violet-500/15 text-violet-700'
	},
	in_progress: {
		label: 'po:status.in_progress',
		tone: 'bg-sky-500/15 text-sky-700'
	},
	completed: {
		label: 'po:status.completed',
		tone: 'bg-emerald-500/15 text-emerald-700'
	},
	archived: {
		label: 'po:status.archived',
		tone: 'bg-stone-500/15 text-stone-600'
	},
	failed: {
		label: 'po:status.failed',
		tone: 'bg-destructive/10 text-destructive'
	}
} as const satisfies Record<PoRun['status'], { label: TKey; tone: string }>

export { RunStatusBadge }
